var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{ show: _vm.show }},[_c('router-link',{staticClass:"site-title",attrs:{"to":"/"}},[_vm._v(" Nick Bayless ")]),_c('Navigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }